// extracted by mini-css-extract-plugin
export default {"modal":"LaModal_modal__+oR+L","modalBody":"LaModal_modalBody__F8oaG"};